import { useState, useEffect } from 'react';
import { settingsAPI, usersAPI } from '../../api';
import { PageHeader, Card, CardHeader, CardBody, Button, Input, Select, Table, Badge } from '../ui';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function SettingsPage() {
  const { user } = useAuth();
  const [tab,    setTab]    = useState('org');
  const [org,    setOrg]    = useState(null);
  const [users,  setUsers]  = useState([]);
  const [roles,  setRoles]  = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    settingsAPI.getOrg().then(r => { setOrg(r.data.org); setRoles(r.data.roles); });
    usersAPI.list().then(r => setUsers(r.data.data));
  }, []);

  const saveOrg = async () => {
    setSaving(true);
    try { await settingsAPI.updateOrg(org); toast.success('Settings saved'); }
    catch { toast.error('Save failed'); }
    finally { setSaving(false); }
  };

  const TABS = [['org','Organisation'],['users','Users & Roles'],['system','System Info']];

  const USER_COLS = [
    { label:'Name', render:r=><span style={{fontWeight:600,color:'var(--ink)'}}>{r.name}</span> },
    { key:'email', label:'Email' },
    { key:'department', label:'Department' },
    { label:'Role', render:r=><Badge variant="blue" dot={false}>{r.role_name}</Badge> },
    { label:'Status', render:r=><Badge variant={r.is_active?'green':'gray'}>{r.is_active?'Active':'Inactive'}</Badge> },
    { label:'Last Login', render:r=>r.last_login?.slice(0,10)||'—' },
  ];

  return (
    <div style={{ maxWidth: 900 }}>
      <PageHeader title="Settings" subtitle="Organisation configuration and user management" />

      {/* Tabs */}
      <div style={{ display:'flex', borderBottom:'1px solid var(--border)', marginBottom:20 }}>
        {TABS.map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            padding:'10px 20px', fontSize:13, fontWeight:tab===k?600:400,
            color:tab===k?'var(--accent)':'var(--ink-soft)', border:'none', background:'none',
            borderBottom:`2px solid ${tab===k?'var(--accent)':'transparent'}`,
            cursor:'pointer', fontFamily:'var(--font)', transition:'all .15s'
          }}>{l}</button>
        ))}
      </div>

      {tab === 'org' && org && (
        <Card>
          <CardHeader title="Organisation Settings" />
          <CardBody>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
              <Input label="Organisation Name" value={org.name||''} onChange={e=>setOrg(o=>({...o,name:e.target.value}))} />
              <Input label="Industry"          value={org.industry||''} onChange={e=>setOrg(o=>({...o,industry:e.target.value}))} />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
              <Select label="Timezone" value={org.timezone||'Asia/Kolkata'} onChange={e=>setOrg(o=>({...o,timezone:e.target.value}))}>
                {[['Asia/Kolkata','IST — Asia/Kolkata'],['UTC','UTC'],['America/New_York','EST — New York'],['Europe/London','GMT — London']].map(([v,l])=><option key={v} value={v}>{l}</option>)}
              </Select>
              <Select label="Currency" value={org.currency||'INR'} onChange={e=>setOrg(o=>({...o,currency:e.target.value}))}>
                {[['INR','₹ INR — Indian Rupee'],['USD','$ USD — US Dollar'],['EUR','€ EUR — Euro'],['GBP','£ GBP — British Pound']].map(([v,l])=><option key={v} value={v}>{l}</option>)}
              </Select>
            </div>
            <Button variant="primary" onClick={saveOrg} loading={saving}>Save Changes</Button>
          </CardBody>
        </Card>
      )}

      {tab === 'users' && (
        <Card>
          <CardHeader title="Users" subtitle={`${users.length} users in organisation`} actions={
            <Button variant="primary" size="sm" onClick={() => toast('User invite form coming soon')}>＋ Invite User</Button>
          } />
          <Table columns={USER_COLS} data={users} emptyMsg="No users found." />
        </Card>
      )}

      {tab === 'system' && (
        <Card>
          <CardHeader title="System Information" />
          <CardBody>
            {[
              ['Application','iAssets EAM v1.0'],
              ['Architecture','React + Fast API + MySQL'],
              ['API Base URL','http://localhost:5000/api'],
              ['Organisation',org?.name],
              ['Your Role',user?.role_name],
              ['Build Date', new Date().toLocaleDateString()],
            ].map(([label,val])=>(
              <div key={label} style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid var(--border)',fontSize:13}}>
                <span style={{color:'var(--ink-muted)'}}>{label}</span>
                <span style={{fontWeight:500,color:'var(--ink)'}}>{val||'—'}</span>
              </div>
            ))}
          </CardBody>
        </Card>
      )}
    </div>
  );
}
